import { z } from 'zod';
import { Lifecycle } from './lifecycles.model';
import { sbefScopeGroupKeys } from '../construction/sbef-custom-groups.data';

const scopeDimensionsSchema = z.object({
  lifecycles: z.array(z.enum(Lifecycle)),
  sbefGroups: z.array(z.enum(sbefScopeGroupKeys)),
  conservative: z.boolean(),
});

/** What a scope counts, independent of its name or storage location. */
export type ScopeDimensions = z.infer<typeof scopeDimensionsSchema>;

/** Project-persisted selection. Saved scopes carry their definition through retirement. */
export const scopeStateSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('preset'),
    presetId: z.string().min(1),
  }),
  z.object({
    kind: z.literal('saved'),
    organization: z.string().min(1),
    preset: z.object({
      id: z.templateLiteral(['saved:', z.string()]),
      label: z.string().trim().min(1).max(80),
      lifecycles: scopeDimensionsSchema.shape.lifecycles,
      sbefGroups: scopeDimensionsSchema.shape.sbefGroups,
      genericClimateData: z.enum(['typical', 'conservative']),
      calculationPeriodYears: z.number().int().positive().max(1000).optional(),
      target: z.number().finite().nonnegative().optional(),
    }),
  }),
  scopeDimensionsSchema.extend({ kind: z.literal('custom') }),
]);

export type ScopeState = z.infer<typeof scopeStateSchema>;
